import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Table, TableName } from '@openx/components-table/Table.tsx';
import { useDealInsightsContext } from '../../../../context/DealInsightsContext.tsx';
import { NoDataComponent } from '../../../shared/NoDataComponent.tsx';
import { useDeliveryByDomainBundleColumns } from './hooks/useDeliveryByDomainBundleColumns.tsx';
import { useDeliveryByDomainBundleData } from './hooks/useDeliveryByDomainBundleData.ts';

export const DeliveryByDomainBundleTable = () => {
  const { dealInsights, criteria, handleCriteriaChange } = useDealInsightsContext();
  const { data: rawData } = dealInsights;
  const theme = useTheme();

  const { data, isLoading } = useDeliveryByDomainBundleData();

  const { columns } = useDeliveryByDomainBundleColumns({
    impressions: {
      max: rawData?.delivery_by_domain_bundle.impressions_range.maximum ?? 0,
      min: rawData?.delivery_by_domain_bundle.impressions_range.minimum ?? 0,
      color: theme.palette.charts.indigo,
    },
    spend: {
      max: rawData?.delivery_by_domain_bundle.spend_range.maximum ?? 0,
      min: rawData?.delivery_by_domain_bundle.spend_range.minimum ?? 0,
      color: theme.palette.charts.lightBlue,
    },
    sov: {
      max: rawData?.delivery_by_domain_bundle.sov_range.maximum ?? 0,
      min: rawData?.delivery_by_domain_bundle.sov_range.minimum ?? 0,
      color: theme.palette.charts.purple,
    },
    ecpm: {
      max: rawData?.delivery_by_domain_bundle.ecpm_range.maximum ?? 0,
      min: rawData?.delivery_by_domain_bundle.ecpm_range.minimum ?? 0,
      color: theme.palette.charts.blue,
    },
    viewability: {
      max: 1,
      min: 0,
      color: theme.palette.charts.pink,
    },
    vcr: {
      max: 1,
      min: 0,
      color: theme.palette.charts.peach,
    },
    ctr: {
      max: rawData?.delivery_by_domain_bundle.ctr_range.maximum ?? 0,
      min: rawData?.delivery_by_domain_bundle.ctr_range.minimum ?? 0,
      color: theme.palette.charts.canary,
    },
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          px: 4,
          pt: 4,
          pb: 1,
          borderBottom: theme => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography variant="h2">Delivery by Domain/Bundle</Typography>
      </Box>

      <Table
        data-test="deal-insights-delivery-by-domain-bundle-table"
        data={data}
        columns={columns}
        loading={isLoading}
        criteria={criteria[TableName.DEAL_INSIGHTS_DELIVERY_BY_DOMAIN_BUNDLE]}
        name={TableName.DEAL_INSIGHTS_DELIVERY_BY_DOMAIN_BUNDLE}
        onCriteriaChange={newCriteria =>
          handleCriteriaChange(newCriteria, TableName.DEAL_INSIGHTS_DELIVERY_BY_DOMAIN_BUNDLE)
        }
        overrideTableCellStyles={{ padding: 0 }}
        skeletonRows={10}
        customNoDataComponent={NoDataComponent}
        stickyActionColumn
      />
    </Box>
  );
};
